module.exports = __webpack_public_path__ + "static/favicon-cd600f295d5650660df8e112d018f6fb.png";